import { useDispatch, useSelector } from 'react-redux';
import SearchWidgetBig from '../components/SearchWidgetBig';
import { getSearchPathWithRequest } from '../../../features/request/helpers';
import { RootState } from '../../../config/redux/types';
import {
  getDurationOptions,
  getOccupancyOptions,
  getNoRegion,
  getNoCity,
  OptionsValue,
} from '../static/staticOptions';
import {
  setCountry,
  setRegion,
  setCity,
  setArrival,
  setDuration,
  setOccupancy,
} from '../../../features/request/actions';

interface SearchWidgetBigContainerProps {
  options?: {
    countries?: OptionsValue[];
  };
  withButton: boolean;
}

export default function SearchWidgetBigContainer({
  options,
  withButton,
}: SearchWidgetBigContainerProps): JSX.Element {
  const request = useSelector((state: RootState) => state.request);
  const dispatch = useDispatch();

  const cities = request.options.cities.length > 0 ? request.options.cities : getNoCity();
  const regions = request.options.regions.length > 0 ? request.options.regions : getNoRegion();

  function handleDurationChange(option: OptionsValue): void {
    const duration = typeof option.value === 'string' ? parseInt(option.value, 10) : option.value;
    dispatch(setDuration(!Number.isNaN(duration) ? duration : null));
  }

  function handleOccupancyChange(option: OptionsValue): void {
    const occupancy = typeof option.value === 'string' ? parseInt(option.value, 10) : option.value;
    dispatch(setOccupancy(!Number.isNaN(occupancy) ? occupancy : 1));
  }

  return (
    <SearchWidgetBig
      options={{
        countries: (options && options.countries) || request.options.countries,
        regions,
        cities,
        durations: getDurationOptions(),
        occupancies: getOccupancyOptions(),
      }}
      values={{
        country: request.countryCode,
        region: request.region,
        city: request.city,
        arrival: request.arrival,
        duration: request.durationOfStay != null ? request.durationOfStay : null,
        occupancy: request.occupancy,
      }}
      countryCode={request.countryCode}
      withButton={withButton}
      actionUrl={getSearchPathWithRequest(request)}
      onCountryChange={(option: OptionsValue): void => {
        dispatch(setCountry(option.value.toString()));
      }}
      onRegionChange={(option: OptionsValue): void => {
        dispatch(setRegion(request.countryCode, option.value.toString()));
      }}
      onCityChange={(option: OptionsValue): void => {
        dispatch(setCity(request.countryCode, request.region, option.value.toString()));
      }}
      onArrivalChange={(date: moment.Moment | null): void => {
        dispatch(setArrival(date));
      }}
      onDurationChange={(duration: OptionsValue): void => handleDurationChange(duration)}
      onOccupancyChange={(option: OptionsValue): void => handleOccupancyChange(option)}
    />
  );
}

const defaultProps: Pick<SearchWidgetBigContainerProps, 'options'> = {
  options: undefined,
};

SearchWidgetBigContainer.defaultProps = defaultProps;
